import React from 'react'

// Drawn from primitives rather than a single filled path (the way most icons
// here are) because a ring-with-spokes is far easier to keep correct as
// stroked circles and lines than as one even-odd path. Sized on the same
// 512 viewBox as icon_info.js so it matches the rest of the sidebar.
export default class IconLifebuoy extends React.Component {

    render() {
        return (
            <svg
                id="icon-lifebuoy"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                fill="none"
                stroke="currentColor"
                strokeWidth="48"
                className={this.props.className}
            >
                <title>support</title>
                <circle cx="256" cy="256" r="200"/>
                <circle cx="256" cy="256" r="96"/>
                {/* The four spokes, each running from the inner ring out to
                    the outer one along a diagonal. */}
                <line x1="188" y1="188" x2="115" y2="115"/>
                <line x1="324" y1="188" x2="397" y2="115"/>
                <line x1="188" y1="324" x2="115" y2="397"/>
                <line x1="324" y1="324" x2="397" y2="397"/>
            </svg>
        )
    }
}
